// The rank bands over the rating (design 15 §16.1 step 21, owner 2026-11-03): five bands 200 wide, the middle one holding 800,
// named East, South, West, North and Dragon, in the order a game goes round and then the dragon.

/** The band's lower edges, in whole rating points: under 500 East, 500–699 South, 700–899 West, 900–1,099 North, 1,100 up Dragon. */
export const RANK_FLOORS = [500, 700, 900, 1100];

/** A rating in hundredths' band, 0 (East) to 4 (Dragon), by the whole number shown. */
export function rankOf(x100: number): number {
  const whole = Math.round(x100 / 100);
  return RANK_FLOORS.filter((f) => whole >= f).length;
}
